import React from 'react';

import { IconLogoWrapper } from './Logo.style';
import { Typography } from '@creditas-ui/typography';

import * as S from './Profile.style';

type ResponsibleProps = {
  name: string;
  email: string;
  cellphone: string;
  cellphoneCode: string;
};

type ProfileProps = {
  name?: string;
  role?: string;
  source?: string;
  responsible?: ResponsibleProps;
  toggle: boolean;
  setToggle: any;
};

type SidebarProfileProps = {
  profile: ProfileProps;
  expanded?: boolean;
  children?: any;
  render?: JSX.Element;
  IconShort?: React.ReactNode;
};

export const SidebarProfile = ({
  expanded = false,
  children,
  profile,
  IconShort,
  render,
}: SidebarProfileProps): JSX.Element | null => {
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!render) return render;
  const { toggle, setToggle } = profile;

  return (
    <S.Profile>
      <S.ProfileLogo>
        <IconLogoWrapper>{IconShort}</IconLogoWrapper>
      </S.ProfileLogo>
      {expanded && React.Children.count(children) === 0 ? (
        <S.Source onClick={() => setToggle(!toggle)}>
          <S.User expanded={expanded}>
            <Typography variant="bodyMdBold" color="neutral.90">
              {profile.name}
            </Typography>
            <Typography variant="bodySmLight" color="neutral.60">
              Código: {profile.source}
            </Typography>
          </S.User>
        </S.Source>
      ) : (
        children
      )}
    </S.Profile>
  );
};
